/**
 * @generated SignedSource<<01f4ec6c44025f94fe9e69b4d9818619>>
 * @relayHash 54386389ce5b1a307c62a145f3b5226f
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 54386389ce5b1a307c62a145f3b5226f

import { ConcreteRequest } from 'relay-runtime';
export type Ch_deleteLaboratoryPrescriptionInput = {
  id: string;
};
export type useChDeleteLaboratoryPrescriptionMutation$variables = {
  input: Ch_deleteLaboratoryPrescriptionInput;
};
export type useChDeleteLaboratoryPrescriptionMutation$data = {
  readonly ch_deleteLaboratoryPrescription: {
    readonly ch_LaboratoryPrescription: {
      readonly id: string;
    } | null;
  };
};
export type useChDeleteLaboratoryPrescriptionMutation = {
  response: useChDeleteLaboratoryPrescriptionMutation$data;
  variables: useChDeleteLaboratoryPrescriptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChDeleteLaboratoryPrescriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deleteLaboratoryPrescriptionPayload",
        "kind": "LinkedField",
        "name": "ch_deleteLaboratoryPrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_LaboratoryPrescription",
            "kind": "LinkedField",
            "name": "ch_LaboratoryPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChDeleteLaboratoryPrescriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deleteLaboratoryPrescriptionPayload",
        "kind": "LinkedField",
        "name": "ch_deleteLaboratoryPrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_LaboratoryPrescription",
            "kind": "LinkedField",
            "name": "ch_LaboratoryPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "54386389ce5b1a307c62a145f3b5226f",
    "metadata": {},
    "name": "useChDeleteLaboratoryPrescriptionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "0e56469bcac774d548cd0ffe0b1299bc";

export default node;
